import { SOLD_SERVICE_STATUS } from '@sales-center/common'

export type ReOpenPopupVariant = 'basic' | 'rejected' | 'submitted'

export function soldServiceStatusToReOpenPopupVariant(
  soldServiceStatus: SOLD_SERVICE_STATUS,
): ReOpenPopupVariant {
  switch (soldServiceStatus) {
    case SOLD_SERVICE_STATUS.Revise:
      return 'rejected'
      break
    case SOLD_SERVICE_STATUS.Submitted:
      return 'submitted'
      break
    default:
      return 'basic'
      break
  }
}
